import PollResponseAnswer from "./PollResponseAnswer";
import PollConstants from "../../screens/admin/Poll/PollConstants";

class PollQuestion {
    pqu_id: string | null | undefined
    pqu_question: string | null | undefined
    pqu_type: string = PollConstants.TYPE_SCORE
    pqu_order: number = 1
    pqu_required: boolean = true
    pqu_poll_id: string | null | undefined

    // Used for dragging in the UI
    local_id: string | null | undefined = new Date().toString()

    removed: boolean = false
    answers: Array<PollResponseAnswer>
    chartData: any
}

export default PollQuestion;